import radiusMiddleware from './radiusMiddleware';

export default [radiusMiddleware];
